const INITIAL_STATE = {
  data: {},
  viewOrder: {},
  addOrder: {},
  updateOrder: {},
  errors: {},
}

const getServiceOrderList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_ORDER_LIST':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_SERVICE_ORDER_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_SERVICE_ORDER':
    return { ...state, ...INITIAL_STATE, addOrder: action.data }
  case 'ADD_SERVICE_ORDER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_SERVICE_ORDER':
    return { ...state, ...INITIAL_STATE, updateOrder: action.data }
  case 'UPDATE_SERVICE_ORDER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'VIEW_SERVICE_ORDER':
    return { ...state, ...INITIAL_STATE, viewOrder: action.data }
  case 'VIEW_SERVICE_ORDER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  // case 'GET_SERVICE_ORDER_FILTER':
  //   return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_SERVICE_ORDER_FILTER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DEACTIVATE_SERVICE_ORDER':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'DEACTIVATE_SERVICE_ORDER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default getServiceOrderList;
